// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"69c1d287","498":"4fa1e4ae","703":"51e59b99","787":"c0fc5690"}[chunkId] + ".chunk.js";
};